// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1CCvK","footer":"ChangeClinic_footer__3heQS"};